import React, { useState, useEffect, useRef } from "react";
import CreditCardForm from "@/components/paymentMethods/creditCard/CreditCardForm";
import CreditCardPaymentButton from "@/components/paymentMethods/creditCard/CreditCardPaymentButton";
import EmailInput from "@/components/EmailInput";
import { Button } from "@/components/ui/button";
import Icons from "@/components/Icons";
import type { CardFormSectionProps } from "@/interfaces";
import IsSaveCardCheckbox from "@/components/paymentMethods/IsSaveCardCheckbox";
import { useAnalytics } from "@/hooks/useAnalytics";

const CardFormSection = ({
  handleSubmit,
  savedCards,
  showApplePay,
  email,
  setEmail,
  emailError,
  setEmailError,
  isSubmitDisabled,
  isLoading,
  handleElementChange,
  onBack,
  saveCard,
  setSaveCard,
  isOneClickContext,
}: CardFormSectionProps) => {
  const [, setIsLandscape] = useState<boolean>(false);
  const { track } = useAnalytics();
  const hasTrackedImpressionRef = useRef(false);

  // Track add payment method impression
  useEffect(() => {
    if (!hasTrackedImpressionRef.current) {
      hasTrackedImpressionRef.current = true;
      try {
        track('impression_add_payment_method', {});
      } catch {
        // Ignore tracking errors
      }
    }
  }, [track]);

  useEffect(() => {
    const checkOrientation = () => {
      const isLandscapeMode = window.innerWidth > window.innerHeight;
      setIsLandscape(isLandscapeMode);
    };

    checkOrientation(); 
    window.addEventListener("resize", checkOrientation);
    window.addEventListener("orientationchange", checkOrientation);

    return () => {
      window.removeEventListener("resize", checkOrientation);
      window.removeEventListener("orientationchange", checkOrientation);
    };
  }, []);

  return (
    <form
      id="card-form"
      onSubmit={handleSubmit}
      className=" mx-5 flex flex-col flex-1 min-h-0 justify-between"
    >
      <div className="flex gap-4 items-center mb-4">
        {/* {!(savedCards.length === 0 && !showApplePay) && ( */}
        {/* {(savedCards.length > 0 || showApplePay || !isOneClickContext) && ( */}
          <Button
            type="button"
            variant="back"
            onClick={onBack}
            className="text-[14px] text-[#A2998B] self-end"
          >
            <span className="rotate-180 inline-block">
              <Icons type="arrow" size={7} />
            </span>
          </Button>
        {/* )} */}

        <h3 className="text-[#212121] font-['Poppins'] text-[15px] font-medium leading-[normal] text-edge-cap leading-trim-both">Pay with a new card</h3>
      </div>
      <div>

            <CreditCardForm
              onElementChange={handleElementChange}
              onAnyFieldFocus={() => {}}
            />
            <EmailInput
              email={email}
              setEmail={setEmail}
              error={emailError}
              setError={setEmailError}
            />
      </div>

      <IsSaveCardCheckbox saveCard={saveCard} setSaveCard={setSaveCard} />

      <div className="flex flex-col gap-2 mt-auto">
        <CreditCardPaymentButton
          isLoading={isLoading}
          isDisabled={isSubmitDisabled}
        />
      </div>
    </form>
  );
};

export default React.memo(CardFormSection);
